// @flow
export { default } from './EventCard';



// WEBPACK FOOTER //
// ./src/components/common/EventCard/index.js